export default class ShowellClient {
    apiClient;
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    signUp(params) {
        return this.apiClient.exec('showell/sign-up', params);
    }
    register(params) {
        const finalParams = {
            user: params.user,
            account: {
                ...params.account,
                x: {
                    settings: params.account.settings &&
                        convertAccountSettings(params.account.settings),
                },
            },
            application: {
                name: params.account.name,
                mainPageTitle: params.account.organization,
            },
            options: {
                ...params.options,
                send_mail: params.options?.sendMail,
                activate: params.options?.activate,
                licenses: params.options?.licenses,
                copy_getting_started: params.options?.copyGettingStarted,
            },
        };
        return this.apiClient.exec('showell/register', finalParams);
    }
    activate(params) {
        return this.apiClient.exec('showell/activate', params);
    }
    requestActivationCode(params) {
        return this.apiClient.exec('showell/request-activation-code', params);
    }
}
const convertAccountSettings = (settings) => ({
    dropbox: { enabled: settings.dropbox?.enabled },
    salesforce: {
        enabled: settings.salesforce?.enabled,
    },
    msdrive: { enabled: settings.msdrive?.enabled },
    analytics: {
        folderAnalyticsEnabled: settings.analytics?.folderAnalyticsEnabled,
    },
    crmEnabled: settings.crm?.enabled,
    hubspot: { enabled: settings.hubspot?.enabled },
    fileEditorEnabled: settings.fileEditor?.enabled,
    myFilesManagementEnabled: settings.myFilesManagement?.enabled,
    shareTrackingEnabled: settings.shareTracking?.enabled,
    translationsEnabled: settings.translationsEnabled,
});
